module.exports = __webpack_public_path__ + "static/img/FuZhuang_jianjiePic_spring.bce2cada.png";